// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + ({"99":"component---themes-gatsby-theme-beluga-src-templates-index-tsx","389":"component---themes-gatsby-theme-beluga-src-pages-404-tsx"}[chunkId] || chunkId) + "-" + {"36":"4ac52d0d80ddb21d5451","99":"6b72b472d1f114b8d1c7","389":"45e822b166ad74b1ab7c","466":"d353dba25a156faa6b3a"}[chunkId] + ".js";
};